import { type ILayout } from "./interfaces";

const data: ILayout = {
  theme: {
    light: "",
    dark: "",
    selected: "dark",
  },
  isDark: true,
  showCssVariables: false,
  isLoaded: false,
};

export default data;
